module.exports = __webpack_public_path__ + "img/CS-UltraLine-II-Repairing.08a0d478.jpg";